import { createSlice } from '@reduxjs/toolkit';

const INITIAL_WEB_SOCKETS_STATE = {
  signOutEventReceived: false,
};

const WebSocketsSlice = createSlice({
  name: 'webSocket',
  initialState: INITIAL_WEB_SOCKETS_STATE,
  reducers: {
    setSignOutEventReceived: (state) => {
      state.signOutEventReceived = true;
    },
  },
});

export const { setSignOutEventReceived } = WebSocketsSlice.actions;

export default WebSocketsSlice.reducer;
